module.exports = __webpack_public_path__ + "img/index3_5.dab6fa9.jpg";